import './NoGrantsView.scss';

export { default } from './NoGrantsView';
